import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { WarehouseProductCollectionItem } from '../../models/warehouse-product-collection-item';
import { WarehouseProductCollectionFilter } from '../../models/warehouse-product-collection-filter';
import { WarehouseProductTypePipe } from '../../pipes/warehouse-product-type.pipe';
import { QuantityUnitPipe } from '@web/shared/module/measurement';

@Component({
  selector: 'app-warehouse-product-list-custom-cell-template',
  imports: [
    CommonModule,
    WarehouseProductTypePipe,
    QuantityUnitPipe,
    TableBodyNoReferenceCellComponent,
  ],
  templateUrl: './warehouse-product-list-custom-cell-template.component.html',
  styleUrl: './warehouse-product-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseProductListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<WarehouseProductCollectionItem, WarehouseProductCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<WarehouseProductCollectionItem>();
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<WarehouseProductCollectionItem>;
}
